module.exports = __webpack_public_path__ + "img/sld_vcb_ta1_no_top_line.f51069b8.svg";